import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getProject } from '../services/webService';
import { GLOBAL } from '../services/global';
import { translate } from '../utils/translations';
import { projectPublishing } from '../utils/projectPublishing';
import { safeUrl } from '../utils/safeUrl';
import './Project.css';

function Project() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [projectSelected, setProjectSelected] = useState(null);
  const [isload, setIsload] = useState(false);

  useEffect(() => {
    const project = getProject(id);
    if (!project) {
      navigate('/home');
      return;
    }

    project.publishing.forEach(publish => {
      if (publish.publishing === GLOBAL.confPublishingWeb.publishing && publish.urlPublishing === 'game')
        publish.urlPublishing = window.location.href + '/game';
      if (publish.publishing === GLOBAL.confPublishingWeb.publishing && publish.urlPublishing === 'maps')
        publish.urlPublishing = window.location.href + '/maps';
    });

    setProjectSelected(project);
    setIsload(true);
  }, [id, navigate]);

  if (!isload || !projectSelected) {
    return <div className="container-custom"><p>Loading...</p></div>;
  }

  return (
    <div className="container-custom">
      <div className="row">
        <div className="col-lg-12">
          <h1 className="page-header">
            <img src={projectSelected.iconImage} alt="" /> {translate(projectSelected.name)}
            <span style={{ fontSize: '65%', color: '#777' }}> {projectPublishing(projectSelected)}</span>
          </h1>
          <ol className="breadcrumb">
            <li><Link to="/home">Home</Link></li>
            &nbsp;/&nbsp;
            <li className="active"> {translate(projectSelected.name)}</li>
          </ol>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          {projectSelected.images && (
            <div id="carouselProject" className="carousel slide" data-ride="carousel"
              style={{ maxWidth: projectSelected.isImageVertical ? '300px' : '768px', margin: '0 auto' }}>
              <div className="carousel-inner">
                {projectSelected.images.map((img, index) => (
                  <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                    <img className="d-block img-fluid" src={img} alt={`Slide ${index + 1}`}
                      style={{ maxHeight: '500px', margin: '0 auto' }} />
                  </div>
                ))}
              </div>
              {projectSelected.images.length > 1 && (
                <>
                  <a className="carousel-control-prev" href="#carouselProject" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a className="carousel-control-next" href="#carouselProject" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                  </a>
                </>
              )}
            </div>
          )}
        </div>

        <div className="col-md-6 page-description">
          <h3>Description</h3>
          <div dangerouslySetInnerHTML={{ __html: translate(projectSelected.description) }}></div>
          <br />
          {projectSelected.details && (
            <div dangerouslySetInnerHTML={{ __html: translate(projectSelected.details) }}></div>
          )}
        </div>
      </div>

      {projectSelected.urlVideo && (
        <>
          <hr />
          <div className="row">
            <div className="col-lg-12">
              <iframe className="video-container-iframe" height="315" width="560"
                src={safeUrl(projectSelected.urlVideo)} allowFullScreen title="video" frameBorder="0">
              </iframe>
            </div>
          </div>
        </>
      )}

      <div className="row">
        <div className="col-lg-12">
          <h3 className="page-header">Available</h3>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="d-flex flex-wrap justify-content-center" style={{ gap: '50px' }}>
            {projectSelected.publishing.map((publish, index) => (
              <div key={index} className="card-item">
                <a title={publish.publishing} href={publish.urlPublishing} target="_blank" rel="noopener noreferrer">
                  <img src={publish.imagePublishing} alt="" className="img-responsive" height="70px" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <h2 className="page-header">Our Team</h2>
          <div className="d-flex flex-wrap justify-content-center" style={{ gap: '50px' }}>
            {projectSelected.team.map((developer, index) => (
              <div key={index} className="card-item-custom">
                {developer.imageDev ? (
                  <img src={developer.imageDev} alt="" className="img-responsive-photo" />
                ) : (
                  <img src="/assets/images/team/avatar.png" alt="" className="img-responsive-photo" />
                )}
                <div className="caption">
                  <h4>{developer.name}<br />
                    <span style={{ fontSize: '65%', color: '#777' }}>{developer.rol}</span>
                  </h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;
